import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import APModal from 'components/Modal/APModal';
import CreateQuickNoteTemplate from './CreateQuickNoteTemplate';
import CreateNoteTemplateSettings from './CreateNoteTemplate.Settings';

const CreateNoteTemplateModal = ({ open, onClose, onCreate }) => {
  const [type, setType] = useState(-1);
  const [title, setTitle] = useState('Create a new note template.');
  const [showCreateSettings, setShowCreateSettings] = useState(false);
  const topRef = useRef(null);
  const [modalSize, setModalSize] = useState('medium');

  useEffect(() => {
    if (!open) {
      setType(-1);
      setTitle('Create a note template.');
      setShowCreateSettings(false);
      setModalSize('medium');
    }
  }, [open]);

  const updateType = (value) => {
    setType(value);
  };

  const updateTitle = () => {
    if (type === 0) {
      setTitle('Create a new shortcut template.');
    }
    else if (type === 1) {
      setTitle('Create a new note template.');
    }
  };

  const openCreateTemplateSettings = () => {
    setShowCreateSettings(true);
    if (type === 2) {
      setModalSize('small');
    } else {
      setModalSize('medium');
    }
    updateTitle();
    topRef.current?.scrollIntoView({ block: 'end' });
  };

  return (
    <>
      <APModal
        open={open}
        title={title}
        name='create-note-template'
        onClose={onClose}
        size={modalSize}
      >
        <div ref={topRef} />
        {showCreateSettings ? (
          <CreateNoteTemplateSettings
            type={type}
            createNoteTemplate={onCreate}
            closeNoteModal={onClose}
          />
        ) : (
          <CreateQuickNoteTemplate
            type={type}
            updateType={updateType}
            openCreateTemplateSettings={openCreateTemplateSettings}
            setModalSize={setModalSize}
          />
        )}
      </APModal>
    </>
  );
};
CreateNoteTemplateModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onCreate: PropTypes.func,
};

CreateNoteTemplateModal.defaultProps = {};

export default CreateNoteTemplateModal;
